import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

const IconPopover = ({ children, content, title }) => (
  <OverlayTrigger
    trigger="click"
    overlay={
      <Popover id="popover-basic">
        <Popover.Title as="h3">{title}</Popover.Title>
        <Popover.Content>
          <small>{content}</small>
        </Popover.Content>
      </Popover>
    }
  >
    {children}
  </OverlayTrigger>
);

export { IconPopover };
